<div
  *ngIf="control.touched && control.hasError(validationRule)"
  class="form-row validation-error"
  [ngClass]="formRowStyleClass"
>
  <span class="col-12 col-form-label" [ngClass]="formLabelStyleClass">{{ validationMessage }}</span>
</div>
